import React from 'react'
import AuthBgWrapper from '@/features/auth/components/auth-bg-wrapper'
import AuthCardWrapper from '@/features/auth/components/auth-card-wrapper'
import SignupFormProvider from '@/features/auth/components/forms/sign-up-form/signup-form-provider'
import { sigUpScreenBgImage } from '@/features/auth/constants/image'
import { SignupFormStepsProvider } from '@/features/auth/context/signup-form-steps-context'
import { SignupUserIdContextProvider } from '@/features/auth/context/signup-user-id-context'
import SucessSignupForm from '@/features/auth/components/forms/sign-up-form/sucess-sign-up-form'
import {  LogIn, PhoneCall } from "lucide-react";
import { AUTH_PAGE_ROUTE } from '@/shared/constants/pages-routes'
import Link from 'next/link'

function Register() {
    return (
        <AuthBgWrapper image={sigUpScreenBgImage}>
            <div className="flex items-center justify-center min-h-screen px-4 gap-28">
                <AuthCardWrapper
                    headerTitle='Create your account'
                    headerDescription='Providing your details and get started in just a few steps!'
                >
                    <SignupFormStepsProvider>
                        <SignupFormProvider>
                            <SignupUserIdContextProvider>
                                <SucessSignupForm />
                            </SignupUserIdContextProvider>
                        </SignupFormProvider>
                    </SignupFormStepsProvider>
                </AuthCardWrapper>
            </div>
        </AuthBgWrapper>
    )
}

export default Register;